import React, { useContext, useRef, useMemo } from 'react';
import { Context } from '@front10/helpers/dist/Context';
import { ThemeProvider } from '@front10/base-elements';
import { EmotionCache } from '../../containers/_commons/emotionCache';
/**
 * Atoms
 */
import { Listbox } from '../../lab/Listbox';
import RadioButtonGroup from '../../elements/RadioButtonGroup';
import Box from '../../elements/Box';
import Text from '../../elements/Text';
/**
 * Hooks
 */
import { useIsMobileView } from '@front10/utils';

const FlightStopCountFilter = (props, ref) => {
  const {
    value,
    labelKey = 'cmp-location-selector-label-number-stops',
    options = [
      { label: 'cmp-stops-options-any', value: 'Any' },
      { label: 'cmp-stops-options-upto', value: '1' },
      { label: 'cmp-stops-options-non', value: '0' }
    ],
    disabled,
    mobileView = false,
    onChange,
    showTitle,
    filterButtonIconProps,
    mobileOrientation = 'horizontal', // horizontal or vertical
    containerStyle,
    titleStyle = {
      fontWeight: 'bold'
    },
    itemsContainerStyle = {},
    itemsStyles = {}
  } = props;

  const {
    translate,
    direction,
    theme: { designTokens }
  } = useContext(Context);

  const title = translate('cmp-number-stops-title', 'Number of Stops');
  const [redemptionUnitValue, setRedemptionValue] = React.useState(value);

  React.useEffect(() => {
    setRedemptionValue(value);
  }, [value]);

  const numberStopsOptions = useMemo(() => {
    return (Array.isArray(options) ? options : []).map((option) => ({
      ...option,
      label: translate(option.label)
    }));
  }, [options, translate]);

  let isMobile = useIsMobileView();
  if (mobileView) {
    isMobile = true;
  }

  const listboxRef = useRef(null);

  React.useImperativeHandle(
    ref,
    () => ({
      focusToggleElement: () => {
        listboxRef.current?.focusToggleElement();
      }
    }),
    []
  );

  const desktopLayout = (
    <Listbox
      ref={listboxRef}
      label={translate(labelKey, 'Select Number of Stops')}
      placeholder={title}
      options={numberStopsOptions}
      defaultValue={value}
      forcePlaceholder={disabled}
      focusWhenIsShow={false}
      disabled={disabled}
      onChange={(value) => onChange({ value })}
      filterButtonIconProps={filterButtonIconProps}
    />
  );

  const mobileLayout = (
    <Box {...containerStyle}>
      {showTitle ? (
        <Text
          variant="text.fontSize5"
          display="flex"
          alignItems="center"
          paddingLeft="5px"
          paddingBottom="15px"
          {...titleStyle}
        >
          {title}
        </Text>
      ) : null}
      <RadioButtonGroup
        options={numberStopsOptions}
        defaultOption={redemptionUnitValue}
        onChange={(newNumberOfStops) => {
          setRedemptionValue(newNumberOfStops);
          props.onChange({ value: newNumberOfStops });
        }}
        orientation={mobileOrientation}
        itemsStyle={itemsStyles}
        itemsContainerStyle={itemsContainerStyle}
      />
    </Box>
  );

  return (
    <EmotionCache direction={direction}>
      <ThemeProvider theme={designTokens}>{!isMobile ? desktopLayout : mobileLayout}</ThemeProvider>
    </EmotionCache>
  );
};

export default React.forwardRef(FlightStopCountFilter);
